export default "__VITE_ASSET__BhrtfgBR__"